import {createSlice} from '@reduxjs/toolkit';
import {httpGet, httpPost} from '../../../util/Rest';
import {CLIENT_FREQUENCY} from '../../../constants/Lookup';
import {CLIENT_MAINTENANCE} from '../../../constants/MicroServiceConstants';

const initialData = {
  addOnChargeData: {},
  addOnChargeStatus: {},
  dropDownData: {},
  isLoading: false,
  errorMsg: null,
  successMsg: null,
};

const slice = createSlice({
  name: 'addOnCharges',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchAddOnChargeData: (state, action) => {
      state.addOnChargeData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchDropDownData: (state, action) => {
      state.dropDownData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    postAddOnChargeData: (state, action) => {
      state.addOnChargeStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    resetStatus: (state) => {
      state.addOnChargeStatus = null;
      state.isLoading = false;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
    resetMsg: (state, action) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
    },
  },
});

export default slice.reducer;

const {
  fetchStart,
  fetchDropDownData,
  fetchError,
  fetchAddOnChargeData,
  postAddOnChargeData,
  resetMsg,
  resetStatus,
} = slice.actions;
export const fetchAddOnCharge = (clientNumber) => {
  return (dispatch) => {
    dispatch(fetchStart());
    Promise.all([
      httpPost('lookup/find/all/lookup', {
        typeCode: [CLIENT_FREQUENCY],
      }),
      httpGet(`${CLIENT_MAINTENANCE}/find/addoncharges/${clientNumber}`),
    ])
      .then((data) => {
        const lookUpApiData = data && data[0] ? data[0] : null;
        const addOnChargeData = data && data[1] ? data[1] : null;
        if (lookUpApiData && lookUpApiData.status && lookUpApiData.status === 200) {
          dispatch(fetchDropDownData(lookUpApiData.data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
        if (addOnChargeData?.status && addOnChargeData.status === 200) {
          dispatch(fetchAddOnChargeData(addOnChargeData.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const postAddOnCharge = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${CLIENT_MAINTENANCE}/save/addoncharges`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postAddOnChargeData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const resetMessage = () => {
  return (dispatch) => {
    dispatch(resetMsg());
  };
};
export const resetAddOnChargeStatus = () => {
  return (dispatch) => {
    dispatch(resetStatus());
  };
};
